import { FormattedMessage } from 'react-intl';

import BasePanel from './BasePanel';

const NoDataCard = () => (
    <BasePanel>
        <div className="text-size-14 margin-top-25">
            <span className="uikit-icon icon-error-sign margin-right-5" />
            <FormattedMessage id="intl-msg:engineOil.noData" />
        </div>
    </BasePanel>
);

export default NoDataCard;
